import { LitElement, html } from '~/lib/bn-lit-element';

class BnToggle extends LitElement {
  createRenderRoot() {
    return this;
  }

  static get properties() {
    return {
      name: { type: String },
      type: { type: String },
      checked: { type: Boolean, reflect: true },
      title: { type: String },
      disabled: { type: Boolean },
    };
  }

  render() {
    return html`
      <div class="form-field">
        <label>
          ${this.title || this.name}
          <input
            type="checkbox"
            name="${this.name}"
            value="on"
            ?checked="${this.checked}"
            ?disabled="${this.disabled}"
            @change="${this._change}"
          />
        </label>
      </div>
    `;
  }

  _change(e) {
    e.stopPropagation();
    this.checked = e.target.checked;
    this.dispatchEvent(new CustomEvent('update', { detail: { value: e.target.checked } }));
  }
}

window.customElements.define('bn-toggle', BnToggle);
